import React, { useState } from 'react';
import './ImprintScreen.css';

interface ImprintScreenProps {
  onBack: () => void;
}

function ImprintScreen({ onBack }: ImprintScreenProps) {
  const [activeTab, setActiveTab] = useState<'about' | 'imprint' | 'privacy'>('about');

  return (
    <div className="imprint-screen">
      <div className="imprint-container">
        <div className="imprint-header">
          <h1 className="imprint-title">Information</h1>
          <button className="back-button" onClick={onBack}>
            ← Back
          </button>
        </div>

        <div className="imprint-tabs">
          <button
            className={`tab-button ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => setActiveTab('about')}
          >
            About
          </button>
          <button
            className={`tab-button ${activeTab === 'imprint' ? 'active' : ''}`}
            onClick={() => setActiveTab('imprint')}
          >
            Impressum
          </button>
          <button
            className={`tab-button ${activeTab === 'privacy' ? 'active' : ''}`}
            onClick={() => setActiveTab('privacy')}
          >
            Datenschutzerklärung
          </button>
        </div>

        <div className="imprint-content">
          {activeTab === 'about' && (
            <div className="tab-content">
              <h2>About Mochi Vocab</h2>
              <p>
                Mochi Vocab is a hobby project of mine, that should fill the niche of an easy to use and convenient vocabulary trainer, that has all the features I could think of ;)
              </p>
              <p>
                Since I though it might be useful for others as well, I decided to add a user management and make it available publicly. If you like it, or would like to give me any feedback / suggestions, please dont hesitate to reach out via info@mochivocab.com.
              </p>
              <p> 
                Mochi Vocabを使ってみてくれてありがとうございます！
              </p>
            </div>
          )}

          {activeTab === 'imprint' && (
            <div className="tab-content">
              <h2>Impressum</h2>
              <div>
                <h3>Angaben gemäß § 5 TMG (Telemediengesetz):</h3>
                <p>
                  <strong>Alexander Thierfelder</strong><br />
                  Münchener Straße 2<br />
                  85748 Garching<br />
                  Deutschland
                </p>
                <p>
                  <strong>Kontakt:</strong><br />
                  E-Mail: info@mochivocab.com
                </p>
                <p>
                  <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong><br />
                  Alexander Thierfelder<br />
                  Münchener Straße 2<br />
                  85748 Garching<br />
                  Deutschland
                </p>
                <h3>Haftungsausschluss:</h3>
                <p>
                  Die Inhalte dieser Webseite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
                </p>
                <p>
                  Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'privacy' && (
            <div className="tab-content">
              <h2>Datenschutzerklärung</h2>
              <div>
                <h3>Verantwortlicher gemäß Art. 4 Nr. 7 DSGVO:</h3>
                <p>
                  Alexander Thierfelder<br />
                  Münchener Straße 2<br />
                  85748 Garching<br />
                  Deutschland<br />
                  E-Mail: info@mochivocab.com
                </p>
                <h3>Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</h3>
                <p>
                  <strong>Beim Besuch der Website:</strong><br />
                  Beim Aufrufen unserer Website werden automatisch Informationen an den Server unserer Website gesendet und temporär gespeichert (z. B. IP-Adresse, Datum und Uhrzeit) zur Sicherstellung eines störungsfreien Betriebs.
                </p>
                <p>
                  <strong>Speicherung in der Datenbank</strong><br />
                  Für die Nutzung unseres Vokabeltrainers speichern wir die Vokabeln, Ihre Benutzereinstellungen sowie personenbezogene Nutzerdaten (Benutzername, verschlüsseltes Passwort, E-Mail-Adresse) in einer gesicherten Datenbank. Dies erfolgt, um Ihnen eine personalisierte Nutzung und Speicherung Ihres Lernfortschritts zu ermöglichen. Die Verarbeitung und Speicherung dieser Daten erfolgt auf Grundlage Ihrer Einwilligung oder zur Erfüllung des Nutzungsvertrags (Art. 6 Abs. 1 lit. b DSGVO).
                </p>
                <p>
                  <strong>Verwendung von JWT und Browser-Speicher</strong><br />
                  Zur Authentifizierung speichern wir ein Anmeldungstoken (JWT) im Browser-Speicher (localStorage/sessionStorage). Dabei werden keine Cookies gesetzt.
                </p>
                <p>
                  <strong>Kontaktformular / Registrierung</strong><br />
                  Bei der Registrierung erheben wir personenbezogene Daten wie Name und E-Mail-Adresse, die ausschließlich zur Bearbeitung Ihrer Anfrage bzw. für die Anmeldung verwendet werden.
                </p>
                <h3>Weitergabe von Daten</h3>
                <p>
                  Eine Weitergabe an Dritte erfolgt nicht, außer dies ist gesetzlich vorgeschrieben oder erforderlich zur Vertragserfüllung.
                </p>
                <h3>Ihre Rechte</h3>
                <p>
                  Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit sowie Widerspruch. Bitte kontaktieren Sie uns bei Fragen oder zur Ausübung Ihrer Rechte über die oben angegebenen Kontaktdaten.
                </p>
                <h3>Speicherdauer</h3>
                <p>
                  Ihre personenbezogenen Daten werden gelöscht, sobald der Zweck der Speicherung entfällt, es sei denn, gesetzliche Aufbewahrungspflichten bestehen.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ImprintScreen;

